/**
 * In-app route history (sessionStorage-backed).
 *
 * Used as a `referrer_fallback` when `document.referrer` is empty — which
 * happens on direct visits and same-origin SPA navigations. We persist the
 * previous in-app pathname so admin attribution (Ask Switzh Logs) can show
 * where the user came from inside the site.
 *
 * Safe in SSR / non-browser environments — every helper guards `window`.
 */

const PREV_KEY = "switzh:prev_in_app_path";
const CURR_KEY = "switzh:curr_in_app_path";

/** Record a new in-app path. Promotes the current path to "previous". */
export function recordInAppPath(path: string): void {
  if (typeof window === "undefined") return;
  try {
    const curr = window.sessionStorage.getItem(CURR_KEY);
    if (curr && curr !== path) {
      window.sessionStorage.setItem(PREV_KEY, curr);
    }
    window.sessionStorage.setItem(CURR_KEY, path);
  } catch {
    // sessionStorage may be unavailable (privacy mode) — ignore.
  }
}

/** Returns the last in-app pathname before the current one, or null. */
export function getPreviousInAppPath(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage.getItem(PREV_KEY);
  } catch {
    return null;
  }
}